import { render, staticRenderFns } from "./binding_student.vue?vue&type=template&id=e629c0a8&scoped=true&"
import script from "./binding_student.vue?vue&type=script&lang=ts&"
export * from "./binding_student.vue?vue&type=script&lang=ts&"
import style0 from "./binding_student.vue?vue&type=style&index=0&id=e629c0a8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e629c0a8",
  null
  
)

export default component.exports